import { Text } from '@gassan-ui'
import { cn } from '@lib/cn'
import Link from 'next/link'
import { FC } from 'react'
import { KontentImage } from './gassan-ui/Image/KontentImage'

type LinkImageProps = {
  variant?: 'horizontal' | 'vertical'
  href: string
  imageSource: string
  title: string
  subtitle?: string
}

export const LinkImage: FC<LinkImageProps> = ({
  variant = 'horizontal',
  href,
  imageSource,
  title,
  subtitle,
}) => {
  return (
    <div
      className={cn(
        'group relative flex w-full overflow-hidden',
        "before:block before:w-full before:transition-all before:duration-300 before:ease-in-out before:content-['']",
        variant === 'horizontal'
          ? ['before:pt-[66%]', 'xl:before:pt-[56%]']
          : ['before:pt-[66%]', 'md:before:pt-[153%]'],
        'hover:before:bg-black/50 hover:before:transition-all hover:before:delay-100 hover:before:duration-300',
      )}
      data-variant={variant}
    >
      <Link href={href} className="absolute left-0 top-0 h-full w-full">
        <KontentImage src={imageSource} className="absolute inset-0 z-[-1]" alt={subtitle || ''} />
        <div
          className={cn(
            'absolute bottom-0 left-0 z-[1] flex w-full items-center py-2',
            'sm:py-4',
            'lg:py-6',
            "before:absolute before:left-0 before:top-0 before:z-[-1] before:block before:h-full before:w-full before:bg-white before:opacity-100 before:transition-all before:duration-300 before:ease-in-out before:content-['']",
            'group-hover:before:translate-y-full group-hover:before:transform group-hover:before:transition-all group-hover:before:duration-300 group-hover:before:ease-in-out',
          )}
          data-content
        >
          <div
            className={cn(
              'border-b border-current pb-1 font-special text-[9px] uppercase leading-[1.45] tracking-[0.28em] opacity-100 transition-all delay-100 duration-100 ease-in-out',
              'md:text-[11px]',
              'group-hover:opacity-0 group-hover:transition-all group-hover:duration-100 group-hover:ease-in-out',
            )}
            data-title
          >
            {title}
          </div>
        </div>
        <div
          className={cn(
            'absolute flex w-full flex-col items-start text-left text-white',
            'bottom-0 left-0 translate-y-2 transform p-6 pl-4 opacity-0 transition-all duration-300 ease-in-out',
            'group-hover:translate-y-0 group-hover:transform group-hover:opacity-100 group-hover:transition-all group-hover:delay-150 group-hover:duration-300 group-hover:ease-in-out',
          )}
          data-hover-content
        >
          <div
            className={cn(
              subtitle ? 'mb-4' : 'mb-0',
              'border-b border-current pb-1 font-special text-[9px] uppercase leading-[1.45] tracking-[0.28em]',
              'md:text-[11px]',
              'translate-y-2 transform opacity-0 transition-all duration-150 ease-in-out',
              'group-hover:translate-y-0 group-hover:transform group-hover:opacity-100 group-hover:transition-all group-hover:duration-150 group-hover:ease-in-out',
            )}
          >
            {title}
          </div>
          {subtitle && <Text className="mb-0 text-white">{subtitle}</Text>}
        </div>
      </Link>
    </div>
  )
}
